import React from "react";
import { useLanguage } from "./LanguageContext";

function Pagination(props){

const { t } = useLanguage();
const shouldScrollToTop = props.scrollToTopOnChange ?? false;

const paginationToShow = 5;
const paginationCount = Math.ceil(props.collection.length / props.resultsOnPage);

function getPages(){
  let result = [];
  const paginagtionCount = paginationCount;

  if (paginagtionCount <= 0){
    return result;
  }

    if (paginagtionCount <= paginationToShow){
    for (let i = 0; i < paginagtionCount; i++) {
      result.push(
    <li key={i} className={"page-item " + (props.pageNumber === i ? "active" : "")}>
      <button type="button" className="page-link" onClick={() => { paginationClick(i) }} aria-current={props.pageNumber === i ? "page" : undefined}>{i + 1}</button>
    </li>
      )
}
    } else {
      const halfIndexDown = Math.floor(paginationToShow / 2);

      let startIndex = 0;
      if (props.pageNumber <= 3){
        startIndex = 0;
      } else if ((props.pageNumber + 1) + halfIndexDown <= paginagtionCount){
        startIndex = props.pageNumber - halfIndexDown;
      } else {
        startIndex = paginagtionCount - paginationToShow;
      }
    
      for (let i = 0; i < paginationToShow; i++) {
        result.push(
          <li key={startIndex + i} className={"page-item " + (props.pageNumber === (startIndex + i) ? "active" : "")}>
                <button type="button" className="page-link" onClick={() => { paginationClick(startIndex + i) }} aria-current={props.pageNumber === (startIndex + i) ? "page" : undefined}>{(startIndex + i) + 1}</button>
          </li>
            )
      }
    }

    return result;
}

function scrollToTop(){
  if (props.search !== undefined){
    props.search();
    return;
  }

  const hero = document.querySelector(".category-title");
  const heroBottom = hero ? hero.getBoundingClientRect().bottom + window.scrollY : 0;
  const targetTop = Math.max(0, heroBottom - 120);

  window.scrollTo({
    top: targetTop,
    behavior: "instant"
  });
}

function paginationClick(value){
  props.setPageNumber(value);
  if (shouldScrollToTop) {
    scrollToTop();
  }
}

return (
      <div className="pagination-navigation" role="navigation" aria-label={t("pagination")}> 
        <ul className="pagination justify-content-center">
      {
        props.collection.length > 0 ? getPages() : null
      }
      </ul>
      </div>
)
}

export default Pagination;